<template>
  <div class="fxgkBox">
    <!-- first -->
    <div class="listTitle">产品推荐</div>
    <div class="kpListBox" v-if="slData&&slData.showFlag=='1'">
      <div class="fxgkListBox">
        <div class="fpListLeft">
          <div class="cptjTitle">
            <div class="text node_name width_270">{{slData.columnTitle}}</div>
            <!-- <span>黑龙江省</span> -->
          </div>
          <div class="cptjJj ellipsis-2">{{slData.columnDesc}}</div>
          <div class="seeMoreXq">
            <div class="cptjCkxq"><!-- 查看详情 --></div>
            <div class="tjImg">
              <img src="../../../../static/images/sltj.svg" alt="">
            </div>
          </div>
          
        </div>
        <!-- 第一种类型 -->
        <div class="showBox">
          <div class="fltjDiv firstDiv">
            <div class="fltjTitle">种植业产品</div>
            <div class="marquee">
              <div class="fltjLi cursor_pointer" v-for="(plantLi,plantIndex) in slData.plantList" @click="seeMoreTj(3,plantLi.geoId)"  :key="plantIndex+'plant'">
                <div class="one">{{plantIndex+1}}</div>
                <div class="two">{{plantLi.geoProdName}}</div>
                <div class="three">{{plantLi.itemName||''}}{{plantLi.avgValue||''}}</div>
              </div>
            </div>
          </div>
          <div class="fltjDiv firstDiv">
            <div class="fltjTitle">畜牧业产品</div>
            <div class="marquee">
              <div class="fltjLi cursor_pointer" v-for="(farmingLi,farmingIndex) in slData.farmingList" :key="farmingIndex+'farmin'" @click="seeMoreTj(3,farmingLi.geoId)">
                <div class="one">{{farmingIndex+1}}</div>
                <div class="two">{{farmingLi.geoProdName}}</div>
                <div class="three">{{farmingLi.itemName||''}}{{farmingLi.avgValue||''}}</div>
              </div>
            </div>
          </div>
          <div class="fltjDiv firstDiv">
            <div class="fltjTitle">水产品</div>
            <div class="marquee">
              <div class="fltjLi cursor_pointer" v-for="(aquaticLi,aquaticIndex) in slData.aquaticList" :key="aquaticIndex+'fltj'" @click="seeMoreTj(3,aquaticLi.geoId)">
                <div class="one">{{aquaticIndex+1}}</div>
                <div class="two">{{aquaticLi.geoProdName}}</div>
                <div class="three">{{aquaticLi.itemName||''}}{{aquaticLi.avgValue||''}}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 结束 -->
      </div>
    </div>

    
    <!-- first copy -->
    <div class="kpListBox twoStyle">
      <div class="fxgkListBox">
        <div class="fpListLeft">
          <div class="cptjTitle">
            <div class="text node_name width_270">{{zbData.columnTitle}}</div>
            <!-- <span>黑龙江省</span> -->
          </div>
          <div class="cptjJj ellipsis-2">{{zbData.columnDesc}}</div>
          <div class="seeMoreXq">
            <div class="cptjCkxq"><!-- 查看详情 --></div>
            <div class="tjImg">
              <img src="../../../../static/images/fwkg.svg" alt="">
            </div>
          </div>
          
        </div>
        <!-- 第一种类型 -->
        <div class="showBox">
          <div class="fltjDiv firstDiv" v-for="(kgfwLi,kgfwInd) in zbData.list.length>3?zbData.list.slice(0,3):zbData.list" :key='kgfwLi.id'>
            <div class="fltjTitle">{{kgfwLi.recName}}</div>
            <div class="">
              <div class="fltjLi cursor_pointer" v-for="(flcpLi,flcpLiIndex) in kgfwLi.list" @click="seeMoreTj(3,flcpLi.geoId)"  :key="flcpLiIndex+'plant'">
                <div class="one">{{flcpLiIndex+1}}</div>
                <div class="two">{{flcpLi.geoProdName}}</div>
                <div class="three">{{flcpLi.avgValue?flcpLi.itemName+flcpLi.avgValue:''}}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 结束 -->
      </div>
    </div>

    <!-- 样式3暂时不用 -->
    <!-- <div class="kpListBox">
      <div class="fxgkListBox">
        <div class="fpListLeft">
          <div class="cptjTitle">
            <div class="text node_name width_270">{{zbData.columnTitle}}</div>
            <span>黑龙江省</span>
          </div>
          <div class="cptjJj ellipsis-2">{{zbData.columnDesc}}</div>
          <div class="seeMoreXq">
            <div class="cptjCkxq">
              查看详情
              </div>
            <div class="tjImg">
              <img src="../../../../static/images/cpfl.svg" alt="">
            </div>
          </div>
          
        </div>
        第三种类型
        <div class="showBox showBoxTh">
          <div class="ogfwList">
            <div class="ogfwLi" :class="kgfwLi.id == kgfwIndex?'activeOgfw':''" v-for="(kgfwLi,kgfwInd) in zbData.list" :key='kgfwLi.id' @click="changeKgfw(kgfwLi.id,kgfwLi.list)">
              <div>{{kgfwLi.recName}}</div>
              <i class="el-icon-caret-top" v-if="kgfwLi.id == kgfwIndex"></i>
            </div>
          </div>
          <div class="fltjDivList">
            <div class="fltjDiv cursor_pointer" v-for="(flcpLi,flcpIndex) in geoList" @click="seeMoreTj(3,flcpLi.geoId)" :key="flcpIndex">
              <div class="flName">
                <img v-if="flcpLi.geoProdUrl" :src="commonUrl+flcpLi.geoProdUrl">
                <img v-else src="../../../../static/images/pro_img.png" alt="">
              </div>
              <div class="flSeeMore node_name">{{ flcpLi.geoProdName }}</div>
              <div class="flSeeMoreXq node_name">{{flcpLi.itemName+flcpLi.avgValue}}</div>
            </div>
          </div>
          
        </div>
      </div>
    </div> -->


    <!-- 样式2 -->
    <div class="kpListBox" v-if="qyData&&qyData.showFlag=='1'">
      <div class="fxgkListBox">
        <div class="fpListLeft">
          <div class="cptjTitle">
            <div class="text node_name width_270">{{qyData.columnTitle}}</div>
            <!-- <span class="dqzh node_name">{{qyData.areaProvZh}}</span> -->
          </div>
          <div class="cptjJj ellipsis-2">{{qyData.columnDesc}}</div>
          <div class="seeMoreXq">
            <div class="cptjCkxq node_name" @click="toseeMore(1,qyData)">{{qyData.address}}</div>
            <div class="tjImg">
              <img src="../../../../static/images/qyts.svg" alt="">
            </div>
          </div>
          
        </div>
        <!-- 第二种类型 -->
        <div class="showBox showBoxT">
          <div class="fltjDivListOHidden">
            <div class="fltjDivListOAll" :style="{'margin-top':-168*proIndexT+'px'}">
              <div class="fltjDivListO">
                <div class="fltjDiv">
                  <div class="fltjLiT cursor_pointer" v-for="(proLi,proIndex) in qyData.proList.slice(0,5)" :key="proIndex+'0id'" @click="seeMoreTj(3,proLi.geoId)">
                    <div class="one">{{proIndex+1}}</div>
                    <!-- <div class="img">
                      <img v-if="proLi.geoProdUrl" :src="commonUrl+proLi.geoProdUrl" alt="">
                      <img v-else src="../../../../static/images/pro_img.png" alt="">
                    </div> -->
                    <div class="two">{{proLi.geoProdName}}</div>
                    <div class="three">{{proLi.areaCityZh}}</div>
                    <div class="four">{{proLi.itemName||''}}{{proLi.avgValue||''}}</div>
                  </div>
                </div>
                <div class="fltjDiv">
                  <div class="fltjLiT fltjLiTTow cursor_pointer" v-for="(proLi,proIndex) in qyData.proList.slice(5,10)" :key="proIndex+'1id'" @click="seeMoreTj(3,proLi.geoId)">
                    <div class="one">{{proIndex+6}}</div>
                    <!-- <div class="img">
                      <img v-if="proLi.geoProdUrl" :src="commonUrl+proLi.geoProdUrl" alt="">
                      <img v-else src="../../../../static/images/pro_img.png" alt="">
                    </div> -->
                    <div class="two">{{proLi.geoProdName}}</div>
                    <div class="three">{{proLi.areaCityZh}}</div>
                    <div class="four">{{proLi.itemName||''}}{{proLi.avgValue||''}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 结束 -->
      </div>
    </div>

    
    <!-- 样式4 -->
    <div class="kpListBox other" v-if="flData&&flData.showFlag=='1'">
      <div class="fxgkListBox">
        <div class="fpListLeft">
          <div class="cptjTitle">
            <div class="text node_name width_270">{{flData.columnTitle}}</div>
            <!-- <span>黑龙江省</span> -->
          </div>
          
        </div>
        <!-- 第四种类型 -->
        <div class="showBox showBoxTh">
          <div class="fltjDivOtherListHidden">
            <div class="fltjDivOtherList" ref="flDiv">
              <div class="fltjDivOther" :style="{'margin':(flAllcount==2)?'6px 0':'23px 0'}" v-for="(flcpLi,flcpIndex) in flData.list.slice(0,15)" :key="flcpIndex" @click="toseeMore(2,flcpLi)">
                <div class="flName">
                  {{ flcpLi.catgName }}
                </div>
                <!-- <div class="flSeeMore" @click="seeMoreTj(3,flcpLi.id)">查看更多</div> -->
              </div>
            </div>

          </div>
        </div>

        
        <!-- 结束 -->
      </div>
    </div>
    <!-- ----- -->
  </div>
</template>

<script>
export default {
  mounted() {},
  data() {
    return {
      proIndexT:0,
      commonUrl,
      flag: "0",
      kgfwIndex:'0',
      kgfwList:[
        {
          'value':'0',
          'label':'按甜度推荐'
        },
        {
          'value':'1',
          'label':'按香气推荐'
        },
        {
          'value':'2',
          'label':'按脆度推荐'
        },
        {
          'value':'3',
          'label':'按综合口感推荐'
        }
      ],
      selectIndex:'0',
      slData:{},
      qyData:{
        proList:[]
      },
      flData:{},
      zbData:{
        list:[]
      },
      geoList:[],
      timer:null,
      flproIndexT:0,
      fltimer:null,
      flAllcount:1,
      kgData:{}
    };
  },
  mounted(){
    this.slInit()
    this.qyInit()
    this.flInit()
    this.zbInit()
    this.getCptjData()
  },
  methods: {
    //获取产品推荐模块信息
    getCptjData(){
      this.Axios({
          url: Action.GETFLOORINDEXSHOWOTHER,
          method: "post",
          data: {
            "sort": 7
          }
      }).then( (res) => {
          var data = res.data;
          console.log(data)
          if(data.code=='000') {
              this.kgData = data.result
          } 
          
      }).catch(function (response) {
          console.log(response);
      });
    },
    startTime(){
      this.timer = setInterval(() => {
          this.proIndexT++
          if(this.proIndexT==Math.ceil(this.qyData.proList.length/10)-1){
            this.proIndexT = 0
          }
      }, 5000);
      

    },
    stopTime(){
      clearTimeout(this.timer)
    },
    flstartTime(){
      this.fltimer = setInterval(() => {
          this.flproIndexT++
          if(this.flproIndexT==this.flAllcount){
            this.flproIndexT = 0
          }
      }, 5000);
    },
    flstopTime(){
      clearTimeout(this.fltimer)
    },
    toseeMore(type,e){
      console.log(e,'eeeee')
      if(type==1){
        this.$router.push({
          path: "productSeach",
          query: {
            areaProv: e.areaProv?e.areaProv:e.areaProv,
            provName: e.areaProvZh?e.areaProvZh:e.areaProvZh,
            cityName: e.areaCityZh?e.areaCityZh:e.areaCityZh,
            areacity:e.areaCity?e.areaCity:e.areaCity,
          },
        });
      }else if(type==2){
        this.$router.push({
          path: "ProductList",
          query: {
            productClassIds: e.productClassIds,
            // catgName: e.catgName
          },
        });
      }
    },
    defalutUrl(e,eve,index){
      this.geoList[index].geoProdUrl = '/1537279/31/17/662a6660a32240348b228e6ce296bde1.png'
    },
    seeMoreTj(type,id){
      window.open('productSeachDetails?id='+id,'_blank');
      // this.$router.push({path:"productSeachDetails",query:{id:id}})
    },
    changeKgfw(index,list){
      this.kgfwIndex = index
      this.geoList = list
    },
    zbInit(){
      this.Axios({
          url: Action.FINDFRECINDEXLIST,
          method: "post",
          data: {"limit":8}
      }).then( (res) => {
          var data = res.data;
          if(data.code=='000') {
              this.zbData = data.result 
              this.kgfwIndex = data.result.list[0].id
              this.geoList = data.result.list[0].list
          } 
          
      }).catch(function (response) {
          console.log(response);
      });
    },
    qyInit(){
      this.Axios({
          url: Action.GETINDEXSHOWAREARECD,
          method: "post",
          data: {"limit":10}
      }).then( (res) => {
          var data = res.data;
          if(data.code=='000') {
              this.qyData = data.result 
              this.qyData.address = data.result.areaProvZh
              if(data.result.areaCityZh){
                this.qyData.address +='-'+data.result.areaCityZh
              }
              if(data.result.areaCouZh){
                this.qyData.address +='-'+data.result.areaCouZh
              }
              this.qyData.proList = this.qyData.proList
          } 
          
      }).catch(function (response) {
          console.log(response);
      });
    },
    slInit(){
      this.Axios({
          url: Action.GETINDEXSHOWSEASON,
          method: "post",
          data: {
          }
      }).then( (res) => {
          var data = res.data;
          if(data.code=='000') {
              this.slData = data.result;
          } 
          
      }).catch(function (response) {
          console.log(response);
      });
    },
    flInit(){
      this.Axios({
          url: Action.GETINDEXSHOWPROCLASS,
          method: "post",
          data: {
          }
      }).then( (res) => {
          var data = res.data;
          if(data.code=='000') {
              this.flData = data.result 
              this.$nextTick(e=>{
                if(this.$refs.flDiv.offsetHeight>66){
                  this.flAllcount = 2
                  // this.flstartTime()
                }
              })
          } 
          
      }).catch(function (response) {
          console.log(response);
      });
    },
    handleClickNav(index) {
      this.flag = index;
    },
    selectHy(index){
        this.selectIndex = index;
        // 接口请求
    },
  },
};
</script>

<style lang="less" scoped>
.fxgkBox {
  width: 100%;
  // background:pink;
  .kpbanner {
    height: 234px;
    background: #2c6eff;
    .kpbCon {
      width: 1180px;
      height: 234px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .conleft {
        width: 795px;
        height: 234px;
        .leftTitle {
          width: 300px;
          height: 50px;
          font-size: 36px;
          color: #ffffff;
          margin: 43px 0 5px;
        }
        .leftCon {
          width: 795px;
          height: 56px;
          line-height: 28px;
          font-size: 20px;
          color: #ffffff;
        }
        .leftBtn {
          width: 104px;
          height: 34px;
          text-align: center;
          line-height: 34px;
          background-color: #ff964a;
          font-size: 14px;
          color: #ffffff;
          margin-top: 20px;
          cursor: pointer;
        }
      }
      .conRight {
        width: 339px;
        height: 234px;
        background-color: #1b52ca;
      }
    }
  }
  .fxgkListBox {
    width: 1180px;
    height: 186px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    border-radius: 4px;
    margin-bottom: 16px;
  }
  .kpListBox {
    width: 1180px;
    margin: 0 auto;
    // height: 186px;
    .fpListLeft {
      width: 310px;
      height: 186px;
    //   box-shadow: 0px 2px 8px 0px #efefef;
      padding: 20px 0 10px 20px;
      border-radius: 4px;
      background-color: #f2f5fa;
      .cptjTitle{
        display: flex;
        height: 28px;
        line-height: 28px;
        .text{
          width: 213px;
          font-family: PingFangSC-Semibold;
          font-size: 20px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #222222;
          font-weight: 600;
        }
        
        .width_270{
          width: 270px;
        }
        span{
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #2c6eff;
          font-weight: 600;
          cursor: pointer;
          width: 82px;
        }
      }
      .cptjJj{
        height: 40px;
        width: 240px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #222222;
        line-height: 20px;
        margin-top: 6px;
      }
      .seeMoreXq{
        display: flex;
        height: 14px;
        margin-top: 60px;
        .tjImg{
          margin-top: -64px;
          img{
            width: 116px;
            height: 97px;
          }
        }
      }
      .cptjCkxq{
        width: 240px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #2c6eff;
        cursor: pointer;
        font-weight: 900;
      }
      .listItem {
        width: 240px;
        height: 48px;
        // padding-left: 38px;
        cursor: pointer;
        .xunhuan {
          display: flex;
          .itemLeft {
            width: 88px;
            height: 89px;
            background-color: #d8d8d8;
            border-radius: 5px;
          }
          .itemRight {
            flex: 1;
            // margin-left: 12px;
            .rightTitle {
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .titleCon {
                width: 240px;
                height: 48px;
                font-size: 16px;
                font-weight: 900;
                color: #222222;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .yjImg {
                width: 14px;
                height: 14px;
              }
            }
            .itemwrite {
              width: 114px;
              font-family: PingFangSC-Regular;
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              height: 48px;
              line-height: 48px;
              letter-spacing: 0px;
              color: #818d99;
              padding-left: 30px;
              border-left: 4px solid transparent;
            }
            .liulan {
              width: 77px;
              height: 20px;
              font-family: PingFangSC-Regular;
              font-size: 12px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 20px;
              letter-spacing: 0px;
              color: #ff964a;
              margin-top: 6px;
            }
          }
            .active{
                border-left: 4px solid #fa6400;
                color: #fa6400;
                background: #fff;
            }
        }
      }
      .xunhuan:hover .itemRight .rightTitle .titleCon {
        color: #2c6eff;
      }
    }
    .seeMoreBox {
      margin: 0 auto 30px;
      display: flex;
      justify-content: space-around;
    }
    .seeMore {
      font-size: 14px;
      color: #ff964a;
      display: flex;
      align-items: center;
    }
    .navListBox {
      width: 940px;
      height: 66px;
      margin: 0 auto;
      border-bottom: solid 1px #dbdbdb;
      display: flex;
      justify-content: space-between;
      padding: 0 50px;
      box-sizing: border-box;
      margin-bottom: 30px;
      .navItemTitle {
        height: 66px;
        font-size: 16px;
        color: #222222;
        display: flex;
        align-items: center;
        cursor: pointer;
      }
      .isnavItemTitle {
        height: 66px;
        font-size: 16px;
        color: #2c6eff;
        display: flex;
        align-items: center;
        border-bottom: 3px solid #2c6eff;
        cursor: pointer;
      }
    }
    .showBox {
      height: 186px;
      width: 854px;
      margin-left: 14px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      background-color: #f2f5fa;
      padding: 10px 20px;
	    border-radius: 4px;
      .fltjDivListOAll{
        width: 814px;
        .fltjDiv{
          height:168px;
        }

      }
      .fltjDivListOHidden{
        height: 168px;
        overflow-y: hidden;
      }
      .fltjDivListO{
        height: 168px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
      }
      .fltjDiv{
        display: block;
        .fltjTitle{
          width: 238px;
          height: 32px;
          padding-bottom: 8px;
          border-bottom: solid 2px #2c6eff;
          text-align: center;
          font-size: 16px;
          font-weight: 600;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #2c6eff;
          margin-bottom: 8px;
          background-color: #f2f5fa;
          z-index: 2;
          position: relative;
        }
        .fltjLi{
          font-family: PingFangSC-Regular;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 24px;
          letter-spacing: 0px;
          color: #5d5e61;
          display: flex;
          text-align: left;
          div{
            display:inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .one{
            width: 22px;
            font-family: DINAlternate-Bold;
            font-size: 14px ;
            color: #5d5e61;
            font-weight: 600;
            // text-align: center;
          }
          .two{
            width: 122px;
            // text-align: center;
          }
          .three{
            width: 96px;
            // text-align: center;
          }
        }
        .fltjLiT{
          font-family: PingFangSC-Regular;
          font-weight: normal;
          font-stretch: normal;
          line-height: 24px;
          letter-spacing: 0px;
          display: flex;
          -webkit-box-pack: justify;
          -ms-flex-pack: justify;
          justify-content: space-between;
          height: 34px;
          padding: 2px 0;
          color: #222222;
          // font-weight: 600;
          font-family: PingFangSC-Regular;
	        font-size: 13px;
          div{
            display:inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .one{
            width: 22px;
            // text-align: center;
            font-family: DIN-Black;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            font-size: 14px ;
            color: #5d5e61;
            font-weight: 600;
          }
          .two{
            width: 98px;
            // text-align: center;
          }
          .three{
            width: 66px;
            // text-align: center;
          }
          .four{
            width: 144px;
            // text-align: center;
          }
          .img{
            width: 30px;
            height: 30px;
            border-radius: 30px;
            background-color: #ced8ea;
            img{
              width: 30px;
              height: 30px;
              border-radius: 30px;
            }
          }
        }
        .fltjLiT:hover{
          color: #2c6eff;
        }
        .fltjLiTTow{
          color: #fff;
          .one{
            color: #6c9cff;
          }
          .img{
            background-color: #fff;
          }
        }
        .fltjLiTTow:hover{
          color: #fff;
        }
      }
      
    }
    .showBoxT{
      background:url('../../../../static/images/qyts.png')  no-repeat   100%;
      .fltjDiv{
        width: 350px;
        font-size: 13px;
      }
    }
    .showBoxTh{
      background-color: #f2f5fa;
      padding: 14px 20px;
      display: block;
      width: 854px;
      // display: flex;
      // justify-content: flex-start;
      .ogfwList{
        display: flex;
        .ogfwLi{
          font-family: PingFangSC-Regular;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #222222;
          width: 98px;
          text-align: center;
          cursor: pointer;
        }
        .activeOgfw{
          color: #2c6eff;
          i{
            color: #2c6eff;
          }
        }
      }
      .fltjDiv{
        width:116px;
        height: 110px;
        text-align: center;
        padding: 0 15px;
        .flName{
          width: 66px;
          height: 66px;
          border-radius: 66px;
          background-image: linear-gradient(180deg, 
      #a1c9ff 0%, 
      #6899fd 100%);
          margin: 0 auto;
          img{
            width: 66px;
            height: 66px;
            border-radius: 66px;
          }
        }
        .flSeeMore{
          cursor: pointer;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #222222;
          margin-top: 12px;
          max-width: 70px;
        }
        .flSeeMoreXq{
          cursor: pointer;
          font-family: PingFangSC-Medium;
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #5d5e61;
          margin-top: 5px;
          max-width: 70px;
        }
      }
      .fltjDiv:first-child{
        margin-left: 0;
      }
    }
    .fltjDivList{
      display: flex;
      justify-content: flex-start;
      margin-top: 12px;
      // margin-left: 30px;
    }
  }
  .kpListBox:first-child{
    padding-top: 30px;
  }
  .twoStyle{
    .showBox{
      justify-content: flex-start;
    }
    .firstDiv{
      margin-right: 44px;
    }
    .firstDiv:last-child{
      margin-right: 0;
    }
  }
  .other{
    .fxgkListBox{
        height: 90px;
      .fpListLeft{
        height: 90px;
        padding: 31px 20px;
      }
    }
    .showBox{
      height: 90px;
      // display: flex;
      padding: 13px 20px;
      // justify-content: flex-start;
      .fltjDivOtherListHidden{
        // height: 32px;
        // overflow: hidden;
      }
      .fltjDivOtherList{
        // height: 32px;
        width: 814px;
      }
      .fltjDivOther{
        // height: 20px;
        // border-radius: 18px;
	      // border: solid 1px #c4d0e4;
        // border-radius: 18px;
        line-height: 20px;
        text-align: center;
        padding: 0 22px;
        color: #566d94;
        margin: 6px 0;
        cursor: pointer;
        display: inline-block;
        border-left: solid 1px #dcdee0;
      }
      .fltjDivOther:first-child{
        border-left: none;
        padding-left: 0;
      }
      .fltjDivOther:hover{
        // background-color: #2c6eff;
	      // border: solid 1px #2c6eff;
        color: #2c6eff;
        text-decoration:underline;
      }
      .fltjDivOther:last-child{
        margin-right: 0;
      }
    }
  }
  .cursor_pointer{
    cursor: pointer;
  }
  .firstDiv{
    height: 156px;
    overflow-y: hidden;
  }
  .firstDiv::-webkit-scrollbar { width: 0 !important }
}


.list-container {
  width: 720px;
  height: 170px;
  margin-left: 13px;
  overflow: hidden;
  position: relative;
}
//无限滚动
.marquee {
  //animation-delay: -5s;
  animation: marquee 15s linear infinite;
}
.marquee:hover {
  animation-play-state: paused;
}
@keyframes marquee {
  0% {
    transform: translateY(0%);
  }
  100% {
    transform: translateY(-51%); //这里不是-100%！
  }
}
    .listTitle {
      margin: 30px auto 30px;
      height: 40px;
      font-family: PingFangSC-Semibold;
      font-size: 28px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 40px;
      letter-spacing: 0px;
      color: #222222;
      font-weight: 900;
      text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/views/homePage/compontents/cptj.vue